module.exports = __webpack_public_path__ + "img/katarina_bedrooms_2.047264c0.jpg";